<h2 mat-dialog-title class="title">
  <span translate="MEETINGS.ADMIN.MANAGE_MEETING_OWNERS.TITLE"></span>
  <a
    class="help-link"
    href="https://help.wiseworks.ai/en/articles/806491-meeting-access-levels"
    target="_blank"
    rel="noopener noreferrer"
    [matTooltip]="'MEETINGS.ADMIN.MANAGE_MEETING_OWNERS.HELP' | translate"
    [attr.aria-label]="'MEETINGS.ADMIN.MANAGE_MEETING_OWNERS.HELP' | translate"
  >
    <mat-icon class="help-icon">help_outline</mat-icon>
  </a>
</h2>
<mat-dialog-content>
  <p class="meeting-name mask-meeting-name">{{ data.meetingName }}</p>
  <p translate="MEETINGS.ADMIN.MANAGE_MEETING_OWNERS.DESCRIPTION"></p>

  @if (people.length > 0) {
    <ul class="meeting-owners">
      @for (person of people; track person.userId) {
        <li>
          <div class="user">
            <div class="name">{{ person.firstName }} {{ person.lastName }}</div>
            <div class="email">{{ person.email }}</div>
          </div>
          <mat-form-field class="role-select" subscriptSizing="dynamic">
            <mat-label translate="MEETINGS.ADMIN.MANAGE_MEETING_OWNERS.ROLE"></mat-label>
            <mat-select
              [value]="person.role"
              (valueChange)="changeRole(person, $event)"
              [attr.aria-label]="'MEETINGS.ADMIN.MANAGE_MEETING_OWNERS.ROLE_FOR' | translate: { userName: person.firstName + ' ' + person.lastName }"
            >
              @for (role of roles; track role) {
                <mat-option [value]="role">{{ roleLabel(role) | translate }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <button
            mat-icon-button
            (click)="removeUser(person)"
            [matTooltip]="'MEETINGS.ADMIN.REVOKE_USER_ACCESS.BUTTON' | translate"
            [attr.aria-label]="'MEETINGS.ADMIN.REVOKE_USER_ACCESS.BUTTON' | translate"
          >
            <mat-icon>person_remove</mat-icon>
          </button>
        </li>
      }
    </ul>
  } @else {
    <p translate="MEETINGS.ADMIN.MANAGE_MEETING_OWNERS.NO_USERS"></p>
  }

  @if (usersResult$ | async; as usersResult) {
    @if (usersResult.isLoading) {
      <app-spinner></app-spinner>
    } @else {
      <div class="add-user">
        <mat-form-field class="user-select" subscriptSizing="dynamic">
          <mat-label translate="MEETINGS.ADMIN.ADD_MEETING_OWNER.SELECT_USER"></mat-label>
          <input
            type="text"
            matInput
            [matAutocomplete]="userAutocomplete"
            [(ngModel)]="filter"
            [placeholder]="'MEETINGS.ADMIN.ADD_MEETING_OWNER.SEARCH_PLACEHOLDER' | translate"
          />
          <mat-autocomplete #userAutocomplete="matAutocomplete">
            @for (user of addableUsers; track user.id) {
              <mat-option [value]="describeUser(user)">{{ describeUser(user) }}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field class="role-select" subscriptSizing="dynamic">
          <mat-label translate="MEETINGS.ADMIN.MANAGE_MEETING_OWNERS.ROLE"></mat-label>
          <mat-select [(ngModel)]="roleToAdd">
            @for (role of roles; track role) {
              <mat-option [value]="role">{{ roleLabel(role) | translate }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <button
          mat-flat-button
          color="primary"
          [disabled]="selectedUser === null"
          (click)="addUser()"
          translate="MEETINGS.ADMIN.ADD_MEETING_OWNER.CONFIRM"
        ></button>
      </div>
    }
  }
</mat-dialog-content>
<mat-dialog-actions class="actions" align="end">
  <button mat-button mat-dialog-close translate="COMMON.CLOSE"></button>
</mat-dialog-actions>
